import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  inject,
} from '@angular/core';

/** Formats an expiry date field as `MM/YY` while typing. */
@Directive({
  selector: '[libExpiryFormat]',
})
export class ExpiryFormatDirective {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  @HostListener('input') onInputChange(): void {
    let input: string = this.el.nativeElement.value.replace(/\D/g, '');

    if (input.length > 2) {
      input = `${input.slice(0, 2)}/${input.slice(2, 4)}`;
    }

    this.renderer.setProperty(this.el.nativeElement, 'value', input);
  }
}
